"use client";

import React from "react";

const gradient = "linear-gradient(110.23deg, #7949CD 6.47%, #6B58F5 44.08%, #0EA7F0 83.15%)";
const reverseGradient = "linear-gradient(110.23deg, #0EA7F0 6.47%, #6B58F5 44.08%, #7949CD 83.15%)";

const CustomButton = ({ title, href, icon, variant = "primary", className = "", style = {}, ...props }) => {
  return (
    <a
      href={href}
      target="_self"
      className={`relative overflow-hidden flex items-center justify-center gap-2 rounded-[50px] uppercase group transition-all duration-300 ${className}`}
      style={{
        margin: "10px",
        padding: "15px 45px",
        minWidth: "220px",
        height: "56px",
        fontWeight: "500",
        cursor: "pointer",
        ...style,
        background: variant === "primary" ? gradient : "transparent",
        border: "2px solid transparent",
        backgroundImage:
          variant === "outline"
            ? `
              linear-gradient(var(--background-primary), var(--background-primary)),
              linear-gradient(110.23deg, #7949CD 6.47%, #6B58F5 44.08%, #0EA7F0 83.15%)
            `
            : gradient,
        backgroundOrigin: "border-box",
        backgroundClip: variant === "outline" ? "padding-box, border-box" : "border-box",
        WebkitBackgroundClip: variant === "outline" ? "padding-box, border-box" : "transparent",
        boxShadow: variant === "primary" ? "0 0 20px rgba(107, 88, 245, 0.30)" : "none",
      }}
      {...props}
    >
      <span
        className={`absolute inset-0 rounded-[50px] transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${
          variant === "primary" ? "translate-x-[-101%] group-hover:translate-x-0" : "translate-x-[-101%] group-hover:translate-x-0"
        }`}
        style={{
          background: variant === "primary" ? reverseGradient : gradient,
          zIndex: 0,
        }}
      />

      <span
        className={`relative z-10 flex items-center gap-2 whitespace-nowrap text-[12px] md:text-[12px] 2xl:text-[18px] transition-all duration-300 ${
          variant === "outline" ? "group-hover:text-white" : "text-white"
        }`}
        style={
          variant === "outline"
            ? {
                background: gradient,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }
            : {}
        }
      >
        <span className={`${variant === "outline" ? "group-hover:[-webkit-text-fill-color:white]" : ""}`}>{title}</span>

        {icon && <span className="flex items-center justify-center text-[24px] transition-transform duration-300 rotate-0 group-hover:rotate-45">{icon}</span>}
      </span>

      {variant === "outline" && (
        <style jsx>{`
          .group:hover span.relative {
            -webkit-text-fill-color: white !important;
            background: none !important;
          }
        `}</style>
      )}
    </a>
  );
};

export default CustomButton;
